export class UserTracker {
    constructor(trackers) {
        this.trackers = [];
        this.identify = (user) => {
            this.trackers.forEach((tracker) => tracker.identify(user));
        };
        this.trackers = trackers.filter((track) => !track.cancelBuild);
    }
    trackEvent(params) {
        const { category, action } = params;
        if (!category || !action) {
            console.error('Error: category and action are required.');
            return;
        }
        this.trackers.forEach((tracker) => tracker.trackEvent(params));
    }
}
